//http://stackoverflow.com/questions/16882171/durandal-knockout-app-with-multilanguage-support
define('i18next-locale',['require','knockout'],function (require) {
    return require('knockout').observable('en');
});

